// extracted by mini-css-extract-plugin
module.exports = {"heigthCover":"WorkWithUs_heigthCover__14hTE","youAre":"WorkWithUs_youAre__3QQv2","displayNoMobile":"WorkWithUs_displayNoMobile__3wrCV"};